// extracted by mini-css-extract-plugin
export default {"change_treatment":"ChangeTreatment_change_treatment__C-G0k","error_msg":"ChangeTreatment_error_msg__kGm-f","save_button":"ChangeTreatment_save_button__aziJs"};